
export function GetRequest(value) {
  //url例子：www.bicycle.com?id="123456"&Name="bicycle"；  
  let url = decodeURIComponent(window.location.href).replace(/\s/g,"+");
  let object = {};
  if (url.indexOf("?") != -1)//url中存在问号，也就说有参数。  
  {
    let str = url.split("?")[1];  //得到?后面的字符串
    let strs = str.split("&");  //将得到的参数分隔成数组[id="123456",Name="bicycle"];
    for (var i = 0; i < strs.length; i++) {
      object[strs[i].split("=")[0]] = strs[i].split("=")[1]
    }
  }
  return object[value];
}



// WEBPACK FOOTER //
// ./src/tool/parameter.js